<script setup lang="ts">
import { RouterView } from 'vue-router'
import NavbarBase from '@/components/navbar/NavbarBase.vue'
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'

// stores
const appStore = useAppStore()

// computed
const showBg = computed(() => !appStore.hideBackground)
</script>

<template>
  <navbar-base v-if="showBg"></navbar-base>
  <RouterView />
</template>

<style scoped></style>
